import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { isEmpty, isNull } from 'lodash'
import { useLocation } from 'react-router-dom'

import {
  Container,
  ContentHeader,
  DialogLogs,
  LoadingFeedback,
  MenuButton,
  Page,
} from 'components'
import { EditForm, SkeletonForm } from './components'

import ThirdPartyManagementStepperProvider from 'providers/ThirdPartyManagementStepperProvider'

import useFetch from 'hooks/useFetch'
import useConvertToFile from 'hooks/useConvertToFile'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

const ThirdPartyManagementMySuppliersEdit = ({ match }) => {
  const { companySupplierId } = match.params
  const location = useLocation()

  const searchParams = new URLSearchParams(location.search)
  const fromCreate = !isNull(searchParams.get('fromCreate'))

  const [openTour, setOpenTour] = useState(false)
  const [openLogDialog, setOpenLogDialog] = useState(false)
  const [activeStep, setActiveStep] = useState(
    location.state?.initialStep ?? (fromCreate ? 1 : 0),
  )

  const { response, refresh } = useFetch(service.dponet.suppliers.get, {
    companySupplierId,
  })

  const { response: responseLogs, isLoading: isLoadingLogs } = useFetch(
    service.dponet.suppliers.logs,
    {
      companySupplierId,
    },
    [openLogDialog],
    openLogDialog,
  )

  const logs = helpers.logs.changeLogs(responseLogs?.data?.dponetAudits || [])
  const companySupplier = response?.data?.companySupplier || {}
  const isPreAvaliation = companySupplier?.preAvaliation

  const { fileList, loading } = useConvertToFile(
    companySupplier?.companySupplierDetail?.attachments,
  )

  const isLoadingAttachments =
    loading ||
    (!fileList && !isNull(companySupplier?.companySupplierDetail?.attachments))

  return (
    <Page
      title={`Gestão de Fornecedores - Atualizar ${
        isPreAvaliation ? 'Pré-Avaliado' : 'Fornecedor'
      }`}
    >
      <Container maxWidth={false}>
        <ContentHeader
          title={`Atualizar ${isPreAvaliation ? 'Pré-Avaliado' : 'Fornecedor'}`}
          breakLine={false}
          preserveSearch
        >
          <Button
            id={
              isPreAvaliation
                ? constants.tours.thirdPartyManagements.STEPS.PRE_AVALIATION
                    .CREATION.EVALUATION[1]
                : constants.tours.thirdPartyManagements.STEPS.CREATION
                    .EVALUATION[1]
            }
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={() => setOpenTour(true)}
          >
            Tutorial
          </Button>

          <MenuButton>
            <Button
              color="secondary"
              onClick={() => setOpenLogDialog(true)}
              fullWidth
            >
              Histórico
            </Button>
          </MenuButton>
        </ContentHeader>

        {isLoadingAttachments ? (
          <SkeletonForm />
        ) : (
          <ThirdPartyManagementStepperProvider
            isEdit
            isPreAvaliation={isPreAvaliation}
            companySupplier={companySupplier}
            refresh={refresh}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            fromCreate={fromCreate}
          >
            <EditForm
              fileList={fileList}
              openTour={openTour}
              setOpenTour={setOpenTour}
            />
          </ThirdPartyManagementStepperProvider>
        )}
      </Container>

      <LoadingFeedback open={isLoadingLogs} />

      <DialogLogs
        logs={isEmpty(logs) ? undefined : logs}
        open={openLogDialog}
        setOpen={setOpenLogDialog}
        showRegisterSession={false}
      />
    </Page>
  )
}

export default ThirdPartyManagementMySuppliersEdit
